const data = {
  development: {
    main: 'http://dev.api.thinkpickle.com.au',
    website: 'http://dev.thinkpickle.com.au',
    portal: 'https://dev.api.backend.thinkpickle.com.au',
    analytics: 'http://dev.analytics.thinkpickle.com.au',
  },
  production: {
    main: 'https://api.thinkpickle.com.au',
    website: 'https://thinkpickle.com.au',
    portal: 'https://api.backend.thinkpickle.com.au',
    analytics: 'https://analytics.thinkpickle.com.au',
  },
  staging: {
    main: 'https://staging.api.thinkpickle.com.au',
    website: 'https://staging.thinkpickle.com.au',
    portal: 'https://dev.api.backend.thinkpickle.com.au',
    analytics: 'https://staging.analytics.thinkpickle.com.au',
  },
}

module.exports = data[window.GLOBAL_ENV.API_TYPE]



// WEBPACK FOOTER //
// ./src/config/api.js